$(".cust-featured-collection .product-grid").slick({
  slidesToShow: 4,
  infinite: false,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  dots: false,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4.png?v=1753182800"></button>',
  nextArrow: '<button type="button" class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4__1.png?v=1753182800"></button>',
  responsive: [
    {
      breakpoint: 1200, // for tablets and below
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768, // for mobile landscape
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480, // for mobile portrait
      settings: {
        slidesToShow: 2,
      }
    }
  ]
});

// Testimonials Slider
$(".testimonials-slider").slick({
  slidesToShow: 1,
  infinite: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  arrows: true, // Enable arrows
  prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4.png?v=1753182800"></button>',
  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4__1.png?v=1753182800"></button>'
});


// Footer menu accordina
$(document).ready(function () {
  function footerAccordion() {
    if ($(window).width() < 749) {
      $('.footer-block--menu .footer-block__details-content').hide(); 
      $('.footer-block--menu .footer-block__heading').off('click').on('click', function () {
        $(this).toggleClass('active');
        $(this).next('.footer-block__details-content').slideToggle();
      });
    } else {
      $('.footer-block--menu .footer-block__details-content').show();
      $('.footer-block--menu .footer-block__heading').off('click');
    }
  }
  footerAccordion();
  $(window).on('resize', footerAccordion);
});


// Read more and read less js
document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector(".cust-sort_description");
  const button = document.querySelector(".read-more-toggle");

  if (!content || !button) return;

  button.addEventListener("click", function () {
    const isExpanded = content.classList.contains("expanded");
    content.classList.toggle("expanded");
    button.textContent = isExpanded ? "Read more" : "Read less";
  });
});
  // document.addEventListener("DOMContentLoaded", function () {
  //   const ul = document.querySelector(".cust-sort_description");
  //   const items = ul.querySelectorAll("li");
  //   const button = document.querySelector(".read-more-toggle");

  //   // Hide all li except first 2
  //   items.forEach((li, index) => {
  //     if (index >= 2) {
  //       li.style.display = "none";
  //     }
  //   });

  //   // Toggle function
  //   button.addEventListener("click", function () {
  //     const isCollapsed = items[2].style.display === "none";

  //     items.forEach((li, index) => {
  //       if (index >= 2) {
  //         li.style.display = isCollapsed ? "list-item" : "none";
  //       }
  //     });

  //     button.textContent = isCollapsed ? "Read less" : "Read more";
  //   });
  // });

// cust product slider

$(".cust-product-slider").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  dots: false,
  prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4.png?v=1753182800"></button>',  // Left arrow (‹)
  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4__1.png?v=1753182800"></button>',  // Right arrow (›)
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 }
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1 }
    }
  ]
});

// Before and After Section slider

$(document).ready(function () {
  $(".before-and-after-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4.png?v=1753182800" alt="Prev"></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4__1.png?v=1753182800" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});

// Before and After images slider

$(document).ready(function () {
  $(".before-and-after-imgslider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4.png?v=1753182800" alt="Prev"></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next"><img src="https://cdn.shopify.com/s/files/1/0037/8952/1008/files/Left_Arrow_4__1.png?v=1753182800" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  $(document).on('click','.cust-text-bannner-sec a',function(){
  var _id = $(this).attr('title');
  $('html, body').animate({
      scrollTop: $(_id).offset().top
    }, 500,)
  })
$.fn.inView = function(){
    var win = $(window);
    obj = $(this);
    var scrollPosition = win.scrollTop();
    var visibleArea = win.scrollTop() + win.height();
    var objEndPos = (obj.offset().top + obj.outerHeight());
    return(visibleArea >= objEndPos && scrollPosition <= objEndPos ? true : false)
};
$(window).scroll(function(){
   var inview = $(".main_ac_btn").inView();
  if(inview == true){
    $('.stick_add_to_cart').hide();
  }
  else{  
  $('.stick_add_to_cart').show();
  }
});
$(document).on('click','.stick_add_to_cart .tab',function(){
var _id = $(this).attr('data-attr');
var $target = $('.richtext .' + _id + ',.review_widget.'+ _id +',.richtext.' + _id +',.tab-main.'+ _id);
console.log(_id);
$('html, body').animate({
scrollTop:$target.offset().top -100
}, 500,)
})
$(document).on('change','.stick_add_to_cart variant-selects select',function(){
   var cb_option = null;
    $('.stick_add_to_cart variant-selects select option:selected').each(function(index){
         var op = $(this).attr('data-option');
        if(index <= 0){
            cb_option = op;
        }else{
            cb_option = `${cb_option}-${op}`;
        }
    })
  var pv_id =  $('.stick_add_to_cart .all_varinats option[data-variant="'+cb_option+'"]').attr('data-id');
  var pv_avl =  $('.stick_add_to_cart .all_varinats option[data-variant="'+cb_option+'"]').attr('data-available');
  var pv_price =  $('.stick_add_to_cart .all_varinats option[data-variant="'+cb_option+'"]').attr('data-price');
  $('.stick_add_to_cart .product__title .sticky_price').text(pv_price);
 $('.stick_add_to_cart product-form .product-variant-id').val(pv_id);
 if(pv_avl == 'true'){
 $('.stick_add_to_cart product-form .product-form__submit span').text('Book Yours Now');
 $('.stick_add_to_cart product-form .product-form__submit').attr('disabled',false);
 }else{
 $('.stick_add_to_cart product-form .product-form__submit span').text('sold out');
 $('.stick_add_to_cart product-form .product-form__submit').attr('disabled',true);
 }

   
})
$('.quantity__button').click(function(){
  var qty =  $(this).parents('quantity-input').find('input').val();
   if($(this).parents().hasClass('stick_add_to_cart')){
   $('.stick_add_to_cart .quantity_input').val(qty);
   }else{
    $('.main_pd .quantity_input').val(qty);
   }
})
});







